import React from 'react';
import UserDimeCard from './UserDimeCard';
import "../containers/App";

const UserDimeCardList = ({ robots, setTest, onRouteChange }) => {
  return (
    <div className="masonry-wrapper">
      {robots.map((user, i) => (
        <div key={i} className="masonry-item">
          <UserDimeCard
            setTest={setTest}
            dime_id={user.dime_id}
            category={user.category}
            rating={user.rating}
            image_key={user.image_key}
            rating_count={user.rating_count}
            onRouteChange={onRouteChange}
          />
        </div>
      ))}
    </div>
  );
};

export default UserDimeCardList;
